import date from "./cc/date";
import msg from "./cc/msg";
import url from "./cc/url";
import rules from "./cc/rules";
import confirm from "./cc/confirm";
import { resetStoreModules } from "./cc/storeReset";
var ccModule = function ccModule(store) {
  return {
    // Set the page title including the project title
    title: function title(_title) {
      return _title + ' - CC Maintainer';
    },
    url: url,
    msg: msg,
    date: date,
    rules: rules,
    confirm: confirm,
    resetStoreModules: resetStoreModules(store)
  };
};
export default (function (_ref) {
  var Vue = _ref.Vue,
    store = _ref.store;
  Vue.prototype.$cc = ccModule(store);
});